import React, { useEffect, useState } from "react";
import "../navbar.css";
import "./dietcondition.css";
import { fetchBlastOffDietRecommendation } from "../actions";
import { useDispatch, useSelector } from "react-redux";
const Dietcondition = ({ ruleResult, kitData, petName }) => {
  const dispatch = useDispatch();
  const [dietRecommendation, setDietRecommendation] = useState();
  const [healthGoals, setHealthGoals] = useState();
  const dietInfo = useSelector(
    (state) => state.dietRecommendation.dietRecommendationInfo
  );
  const requireContext = require.context(
    "../asset/dietImages",
    false,
    /\.(avif|png|jpe?g|gif|webp)$/
  );
  const [conditionItem, setConditions] = useState([]);

  useEffect(() => {
    dispatch(fetchBlastOffDietRecommendation(kitData?.Kit_id));
  }, [dispatch]);

  useEffect(() => {
    const conditions = Object.keys(ruleResult)
      .filter(
        (key) =>
          key !== "foodrecommendations" && key !== "supplementrecommendations"
      )
      .map((key) => ruleResult[key]) // Extract the object value using the key
      .map((condition) => {
        // Filter condition.Results where variable1_value is 'high'
        if (condition.Results && condition.Results.length > 0) {
          const filteredResults = condition.Results.filter(
            (item) => item?.variable1_value === "high"
          );
          return {
            ...condition,
            Results: filteredResults, // Update Results with filtered array
          };
        }
        return condition;
      })
      .filter((condition) => condition.Results && condition.Results.length > 0);
    setConditions(conditions);
  }, [ruleResult]);

  useEffect(() => {
    if (dietInfo?.ItemInfo) {
      const validFoodType = dietInfo.ItemInfo.filter(
        (key) =>
          key.product_type === "food" &&
          key.product_id !== "NONE" &&
          key.product_image !== "NONE" &&
          key.product_name !== "NONE" &&
          key.product_link !== "NONE"
      );
      setDietRecommendation(validFoodType);

      const validSupplementType = dietInfo.ItemInfo.filter(
        (key) =>
          key.product_type === "supplement" &&
          key.product_id !== "NONE" &&
          key.product_image !== "NONE" &&
          key.product_name !== "NONE" &&
          key.product_link !== "NONE"
      );
      setHealthGoals(validSupplementType);
    }
  }, [dietInfo]);

  useEffect(() => {
    console.log("Diet Recommendation:", dietRecommendation, healthGoals);
  }, [dietRecommendation, healthGoals]);

  const handleClick = (myLink) => () => {
    const newWindow = window.open(myLink, "_blank", "noopener,noreferrer");
    if (newWindow) newWindow.opener = null;
  };

  const getImage = (imageName) => {
    if (!imageName) return null;

    // Allow external URLs
    if (imageName.startsWith("http://") || imageName.startsWith("https://")) {
      return imageName;
    }

    try {
      return requireContext(`./${imageName}`);
    } catch (error) {
      console.warn(`Image not found: ${imageName}`);
      return null;
    }
  };

  return (
    <>
      {conditionItem?.length ||
      dietRecommendation?.length ||
      healthGoals?.length ? (
        <div class="container">
          <div className="heading">
            {"\t \t"} Diet & Supplement Recommendation
          </div>
          <div>
            <div className="diet-recommendation">
              <h2>FOOD RECOMMENDATIONS</h2>
              <p>
                Based on {kitData?.PetName}'s DNA,{" "}
                {kitData?.Gender == "Female" ? "she" : "he"} may be at risk for
                high levels of{" "}
                {conditionItem
                  .map(
                    (condition) =>
                      condition.Results?.map((result, index) => {
                        if (result.variable1_value === "high") {
                          let displayName;
                          if (
                            result?.variable1_name?.includes("Classification")
                          ) {
                            displayName = result?.variable1_name?.replace(
                              "Classification",
                              ""
                            );
                          }
                          return displayName;
                        }
                        return null;
                      }).filter(Boolean) // Remove null values
                  )
                  .flat()
                  .map((displayName, index, arr) => (
                    <span key={index}>
                      {displayName}
                      {index < arr.length - 1 ? ", " : ""}
                    </span>
                  ))}
                . Just like people, dogs have individual preferences for flavors
                and foods. To help meet {kitData?.PetName}'s needs, we've
                provided a few options that could be beneficial for{" "}
                {kitData?.Gender == "Female" ? "her" : "him"}. However, we
                recommend consulting your veterinarian to determine the best
                choice for {kitData?.PetName}.
              </p>
            </div>

            <div className="product-recommendations">
              {dietRecommendation?.map((product, index) => (
                <div className="product-container" key={index}>
                  <div
                    className="product-holder"
                    onClick={handleClick(product?.product_link)}
                  >
                    <div key={index} className="product-card">
                      <div className="rank">#{index + 1}</div>
                      <img
                        className="product-cardimg"
                        src={getImage(product?.product_image)}
                        alt={product?.product_name}
                      />{" "}
                    </div>
                    <div className="product-card-name">
                      <p style={{ textAlign: "center" }}>
                        {product?.product_name}
                      </p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
          {healthGoals?.length > 0 && (
            <div>
              <div className="diet-recommendation">
                <h2>NUTRITIONAL AND SUPPLEMENTS RECOMMENDATIONS</h2>
                <p>
                  Considering {kitData?.PetName}'s health goals—anxiety, dental
                  care, and digestive health—we recommend incorporating the
                  following supplements and treats into{" "}
                  {kitData?.Gender == "Female" ? "her" : "his"} diet:
                </p>
              </div>

              <div className="product-recommendations">
                {healthGoals?.map((product, index) => (
                  <div className="product-container" key={index}>
                    <div
                      className="product-holder"
                      onClick={handleClick(product?.product_link)}
                    >
                      <div key={index} className="product-card">
                        <div className="rank">#{index + 1}</div>

                        <img
                          className="product-cardimg"
                          src={getImage(product?.product_image)}
                          alt={product?.product_name}
                          onError={(e) => {
                            e.target.src = "/defaultImage.png";
                          }} // optional fallback
                        />
                      </div>
                      <div className="product-card-name">
                        <p>{product?.product_name}</p>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          )}
          {/* <div className="heading">
                            Health Goals
                        </div> */}
        </div>
      ) : (
        <div className="diet-recommendation">
          <h2 style={{ textAlign: "center" }}>No diet recommended</h2>
        </div>
      )}
    </>
  );
};

export default Dietcondition;
